import { Box, Button, ButtonGroup, Card, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography, Icon } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';
import { Name } from 'ajv';

const Staffs = () => {
    const [details, setDetails] = useState({ email: "" });
    const [open, setOpen] = useState(false);
    const [admins, setAdmins] = useState([])
    const [roleType, setRoleType] = useState('add');
    const handleOpen = (type, item = { email: "" }) => {
        setRoleType(type);
        setDetails(item);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleSave = async (data) => {
        try {
            if (roleType === 'add') {
                // if (data?.email === "" || data?.password === "") {
                //     handleClose()
                //     Swal.fire("All fields are mandatory!")
                // }
                await axios.post(`${URL}/api/admin/iria/create-admin`, data);
                handleClose()
                getAdmins()
                Swal.fire("Successfully created admin!")

            } else {
                await axios.put(`${URL}/api/admin/iria/update/${data?._id}`, data);
                handleClose()
                getAdmins()
                Swal.fire("Successfully edited!")
            }
            handleClose();
        } catch (error) {
            handleClose()
            Swal.fire("Please try again!")
            console.error("Error saving staff member", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${URL}/api/admin/iria/delete-admin?adminId=${id}`);
            Swal.fire("Successfully deleted!")
            getAdmins()
        } catch (error) {
            console.error("Error deleting staff member", error);
        }
    };
    const getAdmins = async () => {
        await axios.get(`${URL}/api/admin/iria/get-all-admins`).then(res => {
            if (res.data) {
                setAdmins(res.data?.data?.allAdmins)
            }
        }).catch(err => {
            console.log(err?.message);

        })
    }
    useEffect(() => {
        getAdmins()
    }, [])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button startIcon={<Icon>add</Icon>} style={{ color: 'white' }} onClick={() => handleOpen('add')} variant='contained' color='primary'
                >                    Add
                </Button>
            </Box>
            <AptaTable
                columns={['Name', 'Email', 'Actions']}
                rows={admins?.map((item) => ({
                    Name: item?.name,
                    Email: item?.email,
                    Actions:
                        <ButtonGroup size='small'>
                            <Button color='info' onClick={() => handleOpen('edit', item)} >
                                <Icon color='info' >edit</Icon>
                            </Button>
                            <Button color="error" onClick={() => handleDelete(item?._id)}>
                                <Icon color='error'>delete</Icon>
                            </Button>
                        </ButtonGroup>
                }))}
            />
            <InputFormModal open={open} onClose={handleClose} onSave={handleSave} details={details} type={roleType} />
        </DashboardLayout>
    );
};

export default Staffs;

const InputFormModal = ({ open, onClose, onSave, details, type }) => {
    const [formData, setFormData] = useState({ email: "", name: "" });

    useEffect(() => {
        if (details) {
            setFormData(details);
        }
    }, [details]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        onSave(formData);
    };

    return (
        <Dialog open={open} maxWidth={'md'} fullWidth onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Admin' : 'Edit Admin'}</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate autoComplete="off">
                    <TextField label="Name" name="name" type="text" value={formData.name} onChange={handleChange} fullWidth margin="normal" />
                    <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} fullWidth margin="normal" />
                    {type === 'add' && (
                        <TextField label="Password" name="password" type="password" value={formData.password} onChange={handleChange} fullWidth margin="normal" />
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={handleSave} color="primary" variant="contained" style={{ color: 'white' }} disabled={type === "add" ? (formData.email === "" || formData.password === "" || formData.name === "") : (formData.email === "" || formData.name === "")}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};
